module.exports = __webpack_public_path__ + "img/score.c0d0dac0.jpeg";